module.exports = __webpack_public_path__ + "static/img/ewm.4d4bc1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/base/Botcon/img/ewm.jpg
// module id = dKAM
// module chunks = 1